import(/* webpackMode: "eager" */ "/codebuild/output/src3692654810/src/bluberries-dash/src/app/page.tsx");
